import EmailWithMetrics from "@mapmycustomers/shared/types/email/EmailWithMetrics";

export interface EmailMetricsCounts {
  clickedCount: number;
  openedCount: number;
  total: number;
}

// Aggregate open/click counts across a set of per-recipient email logs.
// `clickedCount` requires a NON-empty `linksOpened` — `linksOpened` is always an
// array, so a truthy check would count every recipient as a click.
const getEmailMetricsCounts = (emails: EmailWithMetrics[]): EmailMetricsCounts => ({
  clickedCount: emails.filter((email) => (email.linksOpened?.length ?? 0) > 0).length,
  openedCount: emails.filter((email) => email.opened).length,
  total: emails.length,
});

export default getEmailMetricsCounts;
